import { render, staticRenderFns } from "./VSignature.vue?vue&type=template&id=8b505314"
import script from "./VSignature.vue?vue&type=script&lang=js"
export * from "./VSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports